import { useChartDataSelector } from "../useChartDataSelector";

export const getAnalyzeModuleChartDataSelectorSavedValue = (
  portfolioGroupVersionId?: string,
) => ({
  data1Id: localStorage.getItem(
    `EditPortfolioGroupAnalyze_${portfolioGroupVersionId}_data1Id`,
  ),
  data2Id: localStorage.getItem(
    `EditPortfolioGroupAnalyze_${portfolioGroupVersionId}_data1Id`,
  ),
});

export const useAnalyzeModuleChartDataSelector = ({
  portfolioGroupVersionId,
  data1DefaultId,
  data2DefaultId,
}: {
  portfolioGroupVersionId?: string;
  data1DefaultId?: string;
  data2DefaultId?: string;
}) =>
  useChartDataSelector({
    storageKey: `EditPortfolioGroupAnalyze_${portfolioGroupVersionId}`,
    data1DefaultId,
    data2DefaultId,
  });
